export default __webpack_public_path__ + "static/media/contract_tenders_test_upload.7380ca93.csv";